import { render, staticRenderFns } from "./ActivationProposalsView.vue?vue&type=template&id=730937ea&scoped=true&"
import script from "./ActivationProposalsView.vue?vue&type=script&lang=js&"
export * from "./ActivationProposalsView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationProposalsView.vue?vue&type=style&index=0&id=730937ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730937ea",
  null
  
)

export default component.exports